import React, { Component } from 'react';
import {
	type StatusCategory,
	UNDEFINED,
	TODO,
	IN_PROGRESS,
	DONE,
} from '@jira/platform__status-categories/src/status-categories.tsx';
import Lozenge from '@atlaskit/lozenge';

const statusCategoryToAppearenceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

type Props = {
	isActive: boolean;
	category: StatusCategory;
	name: string;
	isFullWidth?: boolean;
};

// eslint-disable-next-line jira/react/no-class-components
export default class StatusLozenge extends Component<Props> {
	static defaultProps = {
		isActive: false,
	};

	render(): React.JSX.Element {
		return (
			<Lozenge
				testId="common-components-status-lozenge.status-lozenge"
				isBold={this.props.isActive}
				appearance={statusCategoryToAppearenceMap[this.props.category]}
				maxWidth={this.props.isFullWidth ? '100%' : undefined}
			>
				{this.props.name}
			</Lozenge>
		);
	}
}
